module.exports = __webpack_public_path__ + "img/kankou_1.77a3838a.jpg";